import { IHeaderAlert } from '../../services/header-service/header-alerts.service';

export default interface IHeaderAlertsState {
  [headerAlertId: string]: IHeaderAlert;
}

export const initializeState = (): IHeaderAlertsState => ({});
